function truncateAtWordBoundary(text, maxLength) {
  if (!Number.isFinite(maxLength)) {
    return text;
  }
  if (!text || text.length <= maxLength) {
    return text;
  }
  const truncated = text.slice(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  let result = '';
  if (lastSpaceIndex > 0) {
    result = truncated.slice(0, lastSpaceIndex).trim();
  } else {
    result = truncated.trim();
  }
  result = result.replace(/[.,;:!?\-—]+$/, '');
  return result + '...';
}

export default truncateAtWordBoundary;
